import { render } from "./DetailPoFulfillmentSupp.vue?vue&type=template&id=a5a4f44e&scoped=true"
import script from "./DetailPoFulfillmentSupp.vue?vue&type=script&lang=js"
export * from "./DetailPoFulfillmentSupp.vue?vue&type=script&lang=js"

import "./DetailPoFulfillmentSupp.vue?vue&type=style&index=0&id=a5a4f44e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a4f44e"]])

export default __exports__